<template>

<i class="icon" :class="{[classType]: true, [className]: true}"></i>

</template>

<script>

export default {

	props: ['name'],

	data: function() {

		return {

			fab: ['tiktok'],
			fas: ['check-circle'],

			map: {
				add: 'plus-square',
				customer: 'user',
				business: 'store',
				dashboard: 'th-large',
				logout: 'sign-out-alt',
				newsletter: 'envelope',
				error: 'exclamation-triangle',
				tick: 'check',
				caret: 'caret-down',
				profile: 'user-edit',
				refer: 'users',
				offers: 'gift',
				email: 'envelope',
				events: 'calendar',
				reviews: 'comments-o',
				review: 'comment-dots',
				scoreFull: 'star',
				scoreEmpty: 'star-o',
				report: 'exclamation-triangle',
				share: 'share-alt',
                pending: 'eye-slash',
                resource: 'file-download',
                supplier: 'truck',
                location: 'map-marker',
                advert: 'bullhorn',
                delete: 'minus-circle',
				website: 'desktop',
				upgrade: 'level-up-alt',
				success: 'check-circle',
				vacancy: 'user-plus'
			}

		}

	},

	computed: {

		classType: function() {

			var type = (this.$_.contains(this.fab, this.name)) ? ' fab' : 'fa'
			type = (this.$_.contains(this.fas, this.name)) ? ' fas' : type

			return type

		},

		className: function() {

			return 'fa-' + ((this.map[this.name]) ? this.map[this.name] : this.name)

		}

	}

}

</script>

<style scoped>

</style>